import { useQuery } from "@tanstack/react-query";

import brandAPIService from "../services/api/brand";
import { BrandCode, TenantCode } from "../models/brand";

function fetchOriginInfoData() {
  return brandAPIService.get();
}

export function useOriginInfoQuery(tenantCode?: TenantCode | BrandCode) {
  return useQuery({
    queryKey: ["originInfo"],
    queryFn: fetchOriginInfoData,
  });
}
